/**
 * Is the ИИ-онбординг on for this deployment?
 *
 * One input: `features.aiOnboarding` in the country config, baked into the build
 * (`VITE_COUNTRY`). Kazakhstan: on for every visitor — owner, 2026-10-15, «ИИ-
 * онбординг врубай на КЗ», no PostHog flag and no A/B. Uzbekistan: off, so its
 * onboarding keeps the category picker and the saved-search builder has no
 * «ИИ заполнит поля» block, exactly as before the feature existed.
 *
 * A build-time constant rather than a flag read in an effect: the value is the
 * same in the prerendered HTML and on the first client render, so there is no
 * hydration flip and no `?ai=` override to reason about.
 */
import type { PublicCountryConfig } from '@tenders/shared';
import { countryConfig } from '../country';

/** The rule itself, for a config other than the active one (tests). */
export function aiOnboardingEnabled(config: Pick<PublicCountryConfig, 'features'>): boolean {
  return config.features.aiOnboarding;
}

/** True when the ИИ step and the ИИ fill block should be shown. */
export function useAiOnboarding(): boolean {
  return aiOnboardingEnabled(countryConfig);
}
